import { endpointMail } from './base.config';

export const mailBilagsky = {
  fetchEmailForward: `${endpointMail}/api/v2/forward-mails`,
  addEmailForward: `${endpointMail}/api/v2/forward-mails`,
  removeEmailForward: `${endpointMail}/api/v2/forward-mails/:uuid`,
  addForwardOldVoucher: `${endpointMail}/api/v2/forward-mails/old-voucher`,
};
